import React, { useState, useEffect } from 'react';
import LoginPage from './pages/LoginPage';
import ChatPage from './pages/ChatPage';
import { getCurrentUser } from './services/api';
import './styles/App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [connectionError, setConnectionError] = useState(false);
  const [lastError, setLastError] = useState(null);
  const [user, setUser] = useState(null);
  const [channels, setChannels] = useState([]);

  // Set page title based on hostname
  useEffect(() => {
    const hostname = window.location.hostname;
    const isLocal = hostname === '192.168.0.38' ||
                    hostname === 'localhost' ||
                    hostname === '127.0.0.1' ||
                    hostname.startsWith('192.168.');

    const suffix = isLocal ? ' (локально)' : '';
    const title = 'Чат приюта Надежда Кузбасса' + suffix;
    document.title = title;
  }, []);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setIsLoading(false);
      return;
    }

    // Есть токен — пытаемся войти бесконечно, пока сервер не ответит
    let attempt = 0;
    let delay = 2000;
    while (true) {
      try {
        const data = await getCurrentUser();
        setUser(data.user);
        setChannels(data.channels);
        setIsAuthenticated(true);
        setIsLoading(false);
        return;
      } catch (error) {
        // Сервер явно отклонил токен — показываем форму входа
        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          setIsLoading(false);
          return;
        }
        // Запоминаем последнюю ошибку для отображения
        const status = error.response?.status;
        const msg = error.response?.data?.error || error.message || 'Неизвестная ошибка';
        setLastError(status ? `HTTP ${status}: ${msg}` : msg);
        // После 5 попыток показываем сообщение о проблеме с сетью
        attempt++;
        if (attempt >= 5) {
          setConnectionError(true);
        }
        // Сетевая ошибка или 5xx — ждём и повторяем
        await new Promise(resolve => setTimeout(resolve, delay));
        delay = Math.min(delay * 2, 30000);
      }
    }
  };

  const handleLoginSuccess = (data) => {
    localStorage.setItem('token', data.token);
    setUser(data.user);
    setChannels(data.channels);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setChannels([]);
    setIsAuthenticated(false);
  };

  const handleForceLogin = () => {
    localStorage.removeItem('token');
    setIsLoading(false);
    setConnectionError(false);
    setLastError(null);
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Загрузка...</p>
        {connectionError && (
          <div className="loading-connection-error">
            <p>Проблема с подключением к серверу.<br />Проверьте интернет на устройстве.</p>
            {lastError && (
              <p style={{ fontSize: '11px', color: '#999', marginTop: '6px', wordBreak: 'break-all' }}>
                {lastError}
              </p>
            )}
            <button
              onClick={handleForceLogin}
              style={{
                marginTop: '12px',
                padding: '8px 20px',
                background: '#e53935',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                cursor: 'pointer'
              }}
            >
              Войти заново
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="App">
      {isAuthenticated ? (
        <ChatPage user={user} channels={channels} onLogout={handleLogout} />
      ) : (
        <LoginPage onLoginSuccess={handleLoginSuccess} />
      )}
    </div>
  );
}

export default App;
